import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

// Carries the current page's Sanity `pageSeo` document (or null) from Gatsby's
// page context down to Layout. This exists so per-page SEO can be added without
// editing every page component to thread a prop.
const PageSeoContext = createContext(null);

export const PageSeoProvider = ({ value, children }) => (
  <PageSeoContext.Provider value={value || null}>{children}</PageSeoContext.Provider>
);

PageSeoProvider.propTypes = {
  value: PropTypes.object,
  children: PropTypes.node,
};

export const usePageSeo = () => useContext(PageSeoContext);
